import { ref, watch } from 'vue'
import { getAuthFileUrl } from '../api'

/**
 * Resolves a stored /uploads/{filename} path to a signed URL.
 *
 * Usage:
 *   const { src } = useAuthFile(computed(() => artisan.photo_url))
 *   // <img :src="src" />
 */
export function useAuthFile(pathRef) {
    const src = ref('')

    async function refresh(path) {
        src.value = await getAuthFileUrl(path)
    }

    watch(pathRef, (path) => refresh(path), { immediate: true })

    return { src }
}
